import { MouseEvent, useRef, useState } from "react";
import { BiSolidXCircle } from "react-icons/bi";
import { SimpleImageBox } from "views/components/CardBodyBoxes/ImageBox";
import styles from "./style.module.scss";
import VisualSimilarityPopover from "views/components/VisualSimilarityPopover";
import { useSearchByRelevanceEnabled } from "hooks/useFeatureFlagHooks";

export interface ImageFileCardProps {
  filename: string;
  imageThumbSrc: string;
  cardElementRef: any;
  onRemoveVertex: (e: MouseEvent) => void;
  onSetVertexSimilarity?: (threshold: string) => void;
}

//temporary added the flag to disable visual similarity threshold feature
const isVisualSimilarityEnabled = false;

export const ImageFileCard = ({
  filename,
  imageThumbSrc,
  cardElementRef,
  onRemoveVertex,
  onSetVertexSimilarity,
}: ImageFileCardProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const isSearchByRelevanceEnabled = useSearchByRelevanceEnabled();

  const title = `Image: ${filename}`;
  const titleRef = useRef<HTMLSpanElement>(null);
  const titleContainerRef = useRef<HTMLDivElement>(null);

  const handleVisualSimilarityApply = (threshold: string) => {
    if (onSetVertexSimilarity) {
      onSetVertexSimilarity(threshold);
    }
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <div
      className={styles.singleClusterWrapper}
      ref={cardElementRef}
      id="clusterCardWrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={styles.dataCard}>
        <div className={styles.cardHead} title={title}>
          <div
            className={styles.cardHeadTitleContainer}
            ref={titleContainerRef}
          >
            <div className={styles.leftSection}>
              <span ref={titleRef} className={styles.titleName}>
                {title}
              </span>
            </div>
            <div className={styles.vertexButton} onClick={onRemoveVertex}>
              Remove <BiSolidXCircle size="16px" />
            </div>
          </div>
        </div>
        <div className={styles.cardBody}>
          <SimpleImageBox image={imageThumbSrc} />
        </div>
        {isHovering &&
          isSearchByRelevanceEnabled &&
          isVisualSimilarityEnabled && (
            <div className={styles.actionButtons}>
              <VisualSimilarityPopover onApply={handleVisualSimilarityApply} />
            </div>
          )}
      </div>
    </div>
  );
};
